/**
 * @generated SignedSource<<646a5ba97535395dbea7b1bdf6a50268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTransferToken_nftItem$data = {
  readonly balanceForUser?: {
    readonly balance: number | null;
  } | null;
  readonly contract: {
    readonly address: string | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly tokenId: string | null;
  readonly " $fragmentType": "useTransferToken_nftItem";
};
export type useTransferToken_nftItem$key = {
  readonly " $data"?: useTransferToken_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTransferToken_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTransferToken_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemBalance",
          "kind": "LinkedField",
          "name": "balanceForUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "181c59bb3ec826f4c2985072b36d22fa";

export default node;
